export default __webpack_public_path__ + "d8ed9473c9db343ede5711dd3abff9ec.png";